export default __webpack_public_path__ + "static/media/cases3@2x.1b8fe4e5.jpg";